import { Button, Input, notification } from 'antd';
import { _FORM_ITEM_LAYOUT, _TAIL_FORM_ITEM_LAYOUT } from '../../../constants';
import { StyledForm } from './style';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useUpdateProfessionalClientOtherMedications } from '../../../hooks/professionals/useClientGeneralInfo';
import { useUpdateClientOtherMedications } from '../../../hooks/client/useClientGeneralInfo';
import { CheckCircleOutlined } from '@ant-design/icons';
import { NotificationTitle } from '../../Common/Notification/style';
import { theme } from '../../../styles/theme';
import { useEffect } from 'react';
import { useGetProfessionalClient } from '../../../hooks/professionals/useProfessionalClient';

const { TextArea } = Input;

const MedicationsForm = () => {
  const [api, contextHolder] = notification.useNotification();
  const [form] = StyledForm.useForm();

  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  const { user } = useSelector((state: RootState) => state.auth);
  const isClient = !!user && "professionalCode" in user;

  const { update: updateOtherMedications, loading: loadingOtherMedications } = useUpdateProfessionalClientOtherMedications();
  const { update: updateClientOtherMedications, loading: loadingClientOtherMedications } = useUpdateClientOtherMedications();
  const { refetch: refetchClient } = useGetProfessionalClient(selectedClient?.id as string);

  useEffect(() => {
    form.setFieldsValue({
      other_medication: selectedClient?.otherMedication?.content !== 'None' ? selectedClient?.otherMedication?.content : ''
    });
  }, [form, selectedClient]);

  const onFinish = async (values: any) => {
    const payload = {
      content: values.other_medication || 'None'
    };

    let res;
    if (selectedClient && !isClient) {
      res = await updateOtherMedications(selectedClient?.id, payload);
      console.log('res', res);
    } else if (isClient) {
      res = await updateClientOtherMedications(payload);
      console.log('res', res);
    }

    if (res?.professionalClientUpdateOtherMedications || res?.clientUpdateOtherMedications) {
      await refetchClient();
      api.info({
        message: <NotificationTitle>Medications updated successfully</NotificationTitle>,
        placement: 'topRight',
        icon:
          <CheckCircleOutlined
            style={{
              color: theme.color.primary,
            }}
          />,
        style: {
          background: `${theme.bg.secondary}`,
          borderRadius: 10,
          alignItems: 'center',
          display: 'flex'
        }
      });
    }
  };

  return (
    <StyledForm
      {..._FORM_ITEM_LAYOUT}
      form={form}
      name="medications_form"
      onFinish={onFinish}
      initialValues={{}}
      style={{ marginTop: '1rem' }}
      scrollToFirstError
    >
      {contextHolder}
      <p>Do you take medicines?</p>
      <small>Type of medicine, name and amount per day:</small>
      <StyledForm.Item name="other_medication">
        <TextArea rows={4} />
      </StyledForm.Item>
      <StyledForm.Item {..._TAIL_FORM_ITEM_LAYOUT}>
        <Button
          type="primary"
          htmlType="submit"
          loading={isClient ? loadingClientOtherMedications : loadingOtherMedications}
        >
          Save
        </Button>
      </StyledForm.Item>
    </StyledForm>
  )
}

export default MedicationsForm;